import { useAuth } from '../../hooks/useAuth'
import { Button } from '../Common/Button'
import { LogOut } from 'lucide-react'
import imgUrl from '../../assets/vizzy.png'

export const Header = () => {
  const { user, logout } = useAuth()

  return (
    <header className="bg-white shadow sticky top-0 z-20">
      <div className="px-4 md:px-6 py-3 md:py-4 flex items-center justify-between gap-4 logo_div">
        <div className="min-w-0 flex-1">
          <img src={`${imgUrl}`} class="logo_img"/>
          <p className="text-xs md:text-sm text-gray-600 truncate">
            {user?.username || 'Пользователь'}
          </p>
        </div>
        <Button
          variant="secondary"
          size="sm"
          onClick={logout}
          className="flex items-center gap-1 md:gap-2 whitespace-nowrap flex-shrink-0"
        >
          <LogOut size={16} className="md:w-[18px] md:h-[18px]" />
          <span className="hidden sm:inline">Выход</span>
        </Button>
      </div>
    </header>
  )
}
